import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EventPricesQueryVariables = Types.Exact<{
  event_id: Types.Scalars['ID'];
  event_account_id: Types.Scalars['ID'];
}>;


export type EventPricesQuery = { __typename?: 'Query', eventPrices: Array<{ __typename?: 'EventPrice', kind: Types.EventPriceKind, container_type_id?: number | null, item_type_id?: number | null, rental_price?: number | null, cleaning_price?: number | null, deposit_price?: number | null, lost_price?: number | null, logistic_partner_cleaning_price?: number | null, is_default: boolean }> };


export const EventPricesDocument = gql`
    query eventPrices($event_id: ID!, $event_account_id: ID!) {
  eventPrices(event_id: $event_id, event_account_id: $event_account_id) {
    kind
    container_type_id
    item_type_id
    rental_price
    cleaning_price
    deposit_price
    lost_price
    logistic_partner_cleaning_price
    is_default
  }
}
    `;

/**
 * __useEventPricesQuery__
 *
 * To run a query within a React component, call `useEventPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventPricesQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      event_account_id: // value for 'event_account_id'
 *   },
 * });
 */
export function useEventPricesQuery(baseOptions: Apollo.QueryHookOptions<EventPricesQuery, EventPricesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventPricesQuery, EventPricesQueryVariables>(EventPricesDocument, options);
      }
export function useEventPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventPricesQuery, EventPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventPricesQuery, EventPricesQueryVariables>(EventPricesDocument, options);
        }
export type EventPricesQueryHookResult = ReturnType<typeof useEventPricesQuery>;
export type EventPricesLazyQueryHookResult = ReturnType<typeof useEventPricesLazyQuery>;
export type EventPricesQueryResult = Apollo.QueryResult<EventPricesQuery, EventPricesQueryVariables>;